var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTicketingNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.5381L22.1127 15.4755L22.2364 14.0689L20.9236 13.7555L20.2364 12.54L19 13.098L17.7636 12.54L17.0764 13.7555L15.7636 14.0651L15.8873 15.4717L15 16.5381L15.8873 17.6007L15.7636 19.0111L17.0764 19.3245L17.7636 20.54L19 19.9781L20.2364 20.5362L20.9236 19.3207L22.2364 19.0072L22.1127 17.6007L23 16.5381Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H6L2 22V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V11H20V4H4V16H12V18Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketingNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TicketingNew.da1f35fb.svg";
export { ForwardRef as ReactComponent };